import {Skeleton} from "@/components/ui/skeleton";

import {PageHeader} from "../../core/components/page-header";

type HomeSkeletonProps = {
  showQuickActions?: boolean;
};

export function HomeSkeleton({showQuickActions = true}: HomeSkeletonProps) {
  return (
    <>
      <PageHeader>
        <PageHeader.TitleWrapper>
          <PageHeader.Title title="Home" />
        </PageHeader.TitleWrapper>
      </PageHeader>

      <div className="p-4 md:p-6">
        <div className="flex h-full flex-col gap-4">
          <div className="grid gap-4 lg:grid-cols-3 lg:items-stretch">
            <div
              className={
                showQuickActions
                  ? "lg:col-span-2 lg:min-h-[18rem]"
                  : "lg:col-span-3 lg:min-h-[18rem]"
              }
            >
              <Skeleton className="min-h-[18rem] w-full" />
            </div>
            {showQuickActions ? (
              <div className="lg:min-h-[18rem]">
                <Skeleton className="min-h-[18rem] w-full" />
              </div>
            ) : null}
          </div>

          <div className="lg:min-h-[24rem]">
            <Skeleton className="min-h-[24rem] w-full" />
          </div>
        </div>
      </div>
    </>
  );
}
